import { render, staticRenderFns } from "./Outresources.vue?vue&type=template&id=18b423e9&scoped=true"
import script from "./Outresources.vue?vue&type=script&lang=js"
export * from "./Outresources.vue?vue&type=script&lang=js"
import style0 from "./Outresources.vue?vue&type=style&index=0&id=18b423e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b423e9",
  null
  
)

export default component.exports